class SptebikSceneShowcase extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-scene-slide]')];
    this.previousButton = this.querySelector('[data-scene-previous]');
    this.nextButton = this.querySelector('[data-scene-next]');
    this.pauseButton = this.querySelector('[data-scene-pause]');
    this.liveRegion = this.querySelector('[data-scene-live]');
    this.current = 0;
    this.interval = Number(this.dataset.interval) || 7000;
    this.playing = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.previousButton?.addEventListener('click', this.showPrevious);
    this.nextButton?.addEventListener('click', this.showNext);
    this.pauseButton?.addEventListener('click', this.togglePlayback);
    this.addEventListener('mouseenter', this.stopTimer);
    this.addEventListener('mouseleave', this.startTimer);
    this.addEventListener('focusin', this.stopTimer);
    this.addEventListener('focusout', this.startTimer);
    this.updatePlaybackLabel();
    this.startTimer();
  }

  disconnectedCallback() {
    this.stopTimer();
    this.previousButton?.removeEventListener('click', this.showPrevious);
    this.nextButton?.removeEventListener('click', this.showNext);
    this.pauseButton?.removeEventListener('click', this.togglePlayback);
    this.removeEventListener('mouseenter', this.stopTimer);
    this.removeEventListener('mouseleave', this.startTimer);
    this.removeEventListener('focusin', this.stopTimer);
    this.removeEventListener('focusout', this.startTimer);
  }

  showPrevious = () => this.show(this.current - 1, true);
  showNext = () => this.show(this.current + 1, true);

  show(index, announce = false) {
    this.current = (index + this.slides.length) % this.slides.length;
    for (const [slideIndex, slide] of this.slides.entries()) {
      const active = slideIndex === this.current;
      slide.setAttribute('aria-hidden', String(!active));
      for (const link of slide.querySelectorAll('a, button')) link.tabIndex = active ? 0 : -1;
    }
    if (announce && this.liveRegion) {
      this.liveRegion.textContent = '';
      requestAnimationFrame(() => { this.liveRegion.textContent = this.slides[this.current].dataset.sceneName || ''; });
    }
    this.startTimer();
  }

  togglePlayback = () => {
    this.playing = !this.playing;
    this.updatePlaybackLabel();
    this.startTimer();
  };

  updatePlaybackLabel() {
    this.classList.toggle('is-playing', this.playing);
    this.pauseButton?.setAttribute('aria-pressed', String(!this.playing));
    if (this.pauseButton) {
      const label = this.playing ? this.pauseButton.dataset.pauseLabel : this.pauseButton.dataset.playLabel;
      this.pauseButton.textContent = this.playing ? '一時停止' : '再生';
      this.pauseButton.setAttribute('aria-label', label || this.pauseButton.textContent);
    }
  }

  startTimer = () => {
    this.stopTimer();
    if (!this.playing || this.slides.length < 2) return;
    this.style.setProperty('--sp-scene-duration', `${this.interval}ms`);
    void this.offsetWidth;
    this.classList.add('is-timing');
    this.timer = window.setTimeout(() => this.show(this.current + 1), this.interval);
  };

  stopTimer = () => {
    if (this.timer) window.clearTimeout(this.timer);
    this.timer = null;
    this.classList.remove('is-timing');
  };
}

if (!customElements.get('sptebik-scene-showcase')) {
  customElements.define('sptebik-scene-showcase', SptebikSceneShowcase);
}

const revealObserver = 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ? new IntersectionObserver((entries, observer) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    }, { threshold: 0.12 })
  : null;

for (const element of document.querySelectorAll('.sp-reveal')) {
  if (revealObserver) revealObserver.observe(element);
  else element.classList.add('is-visible');
}
